module.exports = __webpack_public_path__ + "static/media/4.c4ca1573.png";